// extracted by mini-css-extract-plugin
export default {"content":"Edit_content__ULXCP","btn":"Edit_btn__DXFd7"};